module.exports = __webpack_public_path__ + "img/Komunikasi-Icon0.5c1b4876.png";